import { Logger } from 'simple-logging-lib';
import { PLATFORM_LOGGER } from '../../config/constants';
import { safeCallback } from './safe-callback';
const initialState = {
  isRunning: false,
  completedCount: 0
};
export class AbstractScheduler {
  constructor() {
    this.logger = Logger.getLogger(PLATFORM_LOGGER);
    this.tasks = [];
    this.state = initialState;
    this.onNextTaskCancel = null;
    this.onNextRunCancel = null;
    this.start = null;
    this.start = performance.now();
  }
  enqueue(task) {
    const safeTask = safeCallback(task);
    this.tasks.push(safeTask);
    const {
      isRunning
    } = this.state;
    if (!isRunning) {
      this.run();
    }
  }
  cancel() {
    this.tasks = [];
    if (this.onNextTaskCancel) {
      this.onNextTaskCancel();
    }
    if (this.onNextRunCancel) {
      this.onNextRunCancel();
    }
  }
  run() {
    if (this.tasks.length === 0) {
      this.state = Object.assign({}, this.state, {
        isRunning: false
      });
      return;
    }
    this.onNextTaskCancel = this.schedule(() => {
      this.state = Object.assign({}, this.state, {
        isRunning: true
      });
      const task = this.tasks.shift();
      if (!task) {
        this.state = Object.assign({}, this.state, {
          isRunning: false
        });
        return;
      }
      const timeInSeconds = Math.round((performance.now() - this.start) / 100) / 10;
      this.logger.debug(`Running task. Time elapsed: ${timeInSeconds} seconds.`, task);
      task();
      this.state = Object.assign({}, this.state, {
        completedCount: this.state.completedCount + 1
      });

      // Defer the next run to the next tick of the event loop.
      const timerId = setTimeout(() => this.run(), 0);
      this.onNextRunCancel = () => clearTimeout(timerId);
    });
  }
}